import { Outlet } from "react-router";

export const RootLayout = () => <Outlet />;
